import { colors, typography, spacing, layout } from '../../styles/theme';

export const authColors = {
  panelBg: colors.backgroundDark,
  inputBg: '#333333',
  inputBorder: '#4A4A4A',
  textWhite: '#FFFFFF',
  checkboxWhite: '#F0F0F0',
  textMuted: colors.textSecondary,
  textLight: '#EBEBEB',
  textSubtitle: '#D4D4D4',
  closeIcon: '#D4D4D4',
  linkAccent: colors.primaryLight,
  buttonDisabledBg: '#525252',
  buttonDisabledText: '#B0B0B0',
  divider: colors.border,
  required: colors.error,
};

export const authTitleSx = {
  fontFamily: typography.fontFamily.heading,
  fontWeight: typography.fontWeight.semibold,
  fontSize: '24px',
  lineHeight: '20px',
  letterSpacing: typography.letterSpacing.tight,
  color: authColors.textWhite,
  mt: '38px',
  mb: '6px',
  pr: 4,
};

export const authSubtitleSx = {
  fontFamily: typography.fontFamily.primary,
  fontSize: '20px',
  fontWeight: typography.fontWeight.regular,
  letterSpacing: typography.letterSpacing.tight,
  lineHeight: '20px',
  color: authColors.textSubtitle,
  mt: '12px',
  mb: '52px',
  pr: 2,
};

export const authLabelSx = {
  fontFamily: typography.fontFamily.primary,
  fontWeight: typography.fontWeight.semibold,
  fontSize: '16px',
  lineHeight: '16px',
  letterSpacing: typography.letterSpacing.wide,
  color: authColors.textWhite,
  mb: '8px',
  display: 'block',
};

export const authPlaceholderSx = {
  fontFamily: typography.fontFamily.primary,
  fontSize: '16px',
  fontWeight: typography.fontWeight.regular,
  lineHeight: '20px',
  letterSpacing: typography.letterSpacing.wide,
  color: authColors.textMuted,
  opacity: 1,
};

/** Sobrescribe el fondo celeste/amarillo de :-webkit-autofill del navegador */
export const authInputAutofillSx = {
  '&:-webkit-autofill': {
    WebkitTextFillColor: authColors.textWhite,
    caretColor: authColors.textWhite,
    transition: 'background-color 9999s ease-out 0s',
  },
  '&:-webkit-autofill:hover': {
    WebkitTextFillColor: authColors.textWhite,
  },
  '&:-webkit-autofill:focus': {
    WebkitTextFillColor: authColors.textWhite,
  },
  '&:-webkit-autofill:active': {
    WebkitTextFillColor: authColors.textWhite,
  },
};

export const authTextFieldSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: spacing.borderRadius.md,
    // backgroundColor: 'red',
    color: authColors.textWhite,
    height: 40,
    paddingLeft: '4px',
    '& fieldset': {
      borderColor: '#ABABAB',
    },
    '&:hover fieldset': {
      borderColor: '#666666',
    },
    '&.Mui-focused fieldset': {
      borderColor: colors.primary,
      borderWidth: '2px',
    },
    '&.Mui-disabled': {
      opacity: 1,
      '& fieldset': {
        borderColor: `${authColors.inputBorder} !important`,
      },
    },
    '&.Mui-disabled:hover fieldset': {
      borderColor: `${authColors.inputBorder} !important`,
    },
    '&.Mui-error fieldset': {
      borderColor: `${colors.error} !important`,
    },
    '&.Mui-error:hover fieldset': {
      borderColor: `${colors.error} !important`,
    },
    '&.Mui-error.Mui-focused fieldset': {
      borderColor: `${colors.error} !important`,
      borderWidth: '2px',
    },
  },
  '& .MuiOutlinedInput-input': {
    fontFamily: typography.fontFamily.primary,
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: typography.fontWeight.regular,
    color: authColors.textWhite,
    padding: '12px 14px',
    '&::placeholder': authPlaceholderSx,
    '&::-webkit-input-placeholder': authPlaceholderSx,
    '&::-moz-placeholder': authPlaceholderSx,
    '&:-ms-input-placeholder': authPlaceholderSx,
    ...authInputAutofillSx,
  },
  '& .MuiOutlinedInput-input.Mui-disabled': {
    WebkitTextFillColor: authColors.textWhite,
    color: authColors.textWhite,
    opacity: 0.72,
  },
  '& .MuiInputAdornment-root': {
    marginRight: 0,
  },
  '& .MuiInputAdornment-root .MuiSvgIcon-root': {
    opacity: 1,
  },
  '& .MuiOutlinedInput-root.Mui-disabled .MuiInputAdornment-root .MuiSvgIcon-root': {
    color: 'rgba(255,255,255,0.72)',
    opacity: 0.72,
  },
};

export const authInputIconSx = {
  fontSize: 20,
  color: 'rgba(255,255,255,0.72)',
};

export const authLinkAccentSx = {
  fontFamily: typography.fontFamily.primary,
  fontWeight: typography.fontWeight.regular,
  fontSize: '16px',
  lineHeight: '16px',
  letterSpacing: typography.letterSpacing.wide,
  color: authColors.linkAccent,
  cursor: 'pointer',
  textDecoration: 'underline',
  textUnderlineOffset: '4px',
  border: 'none',
  background: 'none',
  padding: 0,
  '&:hover': {
    color: colors.primary,
  },
};

export const authPrimaryButtonSx = {
  textTransform: 'none',
  fontFamily: typography.fontFamily.primary,
  fontWeight: typography.fontWeight.medium,
  fontSize: '16px',
  lineHeight: '18.41px',
  height: 44,
  minHeight: 44,
  flexShrink: 0,
  borderRadius: spacing.borderRadius.md,
  boxShadow: 'none',
  backgroundColor: colors.primary,
  color: authColors.textWhite,
  '&:hover': {
    backgroundColor: colors.primaryHover,
    boxShadow: 'none',
  },
  '&.Mui-disabled': {
    backgroundColor: authColors.buttonDisabledBg,
    color: authColors.buttonDisabledText,
  },
};

export const authGoogleButtonSx = {
  textTransform: 'none',
  fontFamily: typography.fontFamily.primary,
  fontWeight: typography.fontWeight.medium,
  fontSize: '16px',
  lineHeight: '18.41px',
  height: 44,
  minHeight: 44,
  flexShrink: 0,
  borderRadius: spacing.borderRadius.md,
  backgroundColor: '#FFFFFF',
  color: '#1A1A1A',
  border: 'none',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#F5F5F5',
    boxShadow: 'none',
  },
  '&.Mui-disabled': {
    backgroundColor: '#E0E0E0',
    color: '#9E9E9E',
  },
};

export const AUTH_PANEL_INSET = {
  xs: '16px',
  sm: '24px',
};

/** Dimensiones del frame en Figma (Crear cuenta / Login) */
export const AUTH_PANEL_WIDTH = 584;
export const AUTH_PANEL_HEIGHT = 928;

export const authPanelWrapperSx = {
  width: {
    xs: `min(${AUTH_PANEL_WIDTH}px, calc(100vw - 32px))`,
    sm: `min(${AUTH_PANEL_WIDTH}px, calc(100vw - 48px))`,
  },
  maxWidth: AUTH_PANEL_WIDTH,
  height: {
    xs: `min(${AUTH_PANEL_HEIGHT}px, calc(100dvh - ${layout.mapHeaderHeight}px - 32px))`,
    sm: `min(${AUTH_PANEL_HEIGHT}px, calc(100dvh - ${layout.mapHeaderHeight}px - 48px))`,
  },
  maxHeight: {
    xs: `calc(100dvh - ${layout.mapHeaderHeight}px - 32px)`,
    sm: `calc(100dvh - ${layout.mapHeaderHeight}px - 48px)`,
  },
  flexShrink: 0,
};

/** PanelShell desktop: mismo offset que AuthLayout (header + inset superior) y altura de authPanelWrapperSx */
export const mapPanelDesktopLayoutSx = {
  top: {
    sm: `calc(${layout.mapHeaderHeight}px + ${layout.mapPanelTopInset}px)`,
  },
  height: {
    sm: `min(${AUTH_PANEL_HEIGHT}px, calc(100dvh - ${layout.mapHeaderHeight}px - 48px))`,
    md: `min(${AUTH_PANEL_HEIGHT}px, calc(100dvh - ${layout.mapHeaderHeight}px - 48px))`,
  },
  maxHeight: {
    sm: `calc(100dvh - ${layout.mapHeaderHeight}px - 48px)`,
    md: `calc(100dvh - ${layout.mapHeaderHeight}px - 48px)`,
  },
};

export const authPanelSx = {
  width: '100%',
  height: '100%',
  minHeight: 0,
  maxHeight: '100%',
  padding: { xs: '24px 20px 28px', sm: '42px 28px 42px' },
  backgroundColor: authColors.panelBg,
  border: `1px solid ${authColors.inputBorder}`,
  borderRadius: '16px',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.35)',
  position: 'relative',
  overflowY: 'auto',
  boxSizing: 'border-box',
  '&::-webkit-scrollbar': { width: '6px' },
  '&::-webkit-scrollbar-track': { background: 'transparent' },
  '&::-webkit-scrollbar-thumb': { background: 'rgba(255,255,255,0.2)', borderRadius: '3px' },
};

export const authPanelFlexSx = {
  ...authPanelSx,
  display: 'flex',
  flexDirection: 'column',
};

export const authFooterSx = {
  fontFamily: typography.fontFamily.primary,
  fontSize: '16px',
  lineHeight: '20px',
  fontWeight: typography.fontWeight.regular,
  opacity: 0.85,
  color: '#D4D4D4',
  textAlign: 'left',
};

export const authSecondaryLinkRowSx = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '6px',
  mt: '24px',
  mb: '16px',
};

export const authCloseButtonSx = {
  position: 'absolute',
  top: 16,
  right: 16,
  color: authColors.closeIcon,
  padding: '4px',
  '&:hover': {
    backgroundColor: 'rgba(255,255,255,0.08)',
  },
};

export const authFieldErrorSx = {
  fontSize: typography.fontSize.xs,
  fontFamily: typography.fontFamily.primary,
  fontWeight: typography.fontWeight.regular,
  color: colors.error,
  mt: '6px',
  textAlign: 'left',
  lineHeight: typography.lineHeight.tight,
};

export const authInfoAlertSx = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  height: 45,
  backgroundColor: '#2470CC',
  border: '2px solid #75AAEE',
  borderRadius: '10px',
  padding: '15px 16px',
  mb: '24px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
};

export const authInfoAlertTextSx = {
  fontFamily: typography.fontFamily.primary,
  fontSize: '14px',
  lineHeight: '20px',
  fontWeight: typography.fontWeight.regular,
  color: authColors.textWhite,
};

export const otpDigitSx = {
  width: 72,
  flexShrink: 0,
  '& .MuiOutlinedInput-root': {
    width: 72,
    height: 84,
    borderRadius: spacing.borderRadius.md,
    color: authColors.textWhite,
    padding: 0,
    '& fieldset': {
      borderColor: '#ABABAB',
    },
    '&:hover fieldset': {
      borderColor: '#666666',
    },
    '&.Mui-focused fieldset': {
      borderColor: colors.primary,
      borderWidth: '2px',
    },
    '&.Mui-disabled': {
      opacity: 1,
      '& fieldset': {
        borderColor: `${authColors.inputBorder} !important`,
      },
    },
  },
  '& .MuiOutlinedInput-input': {
    fontFamily: typography.fontFamily.primary,
    fontSize: '20px',
    fontWeight: typography.fontWeight.medium,
    lineHeight: '24px',
    color: authColors.textWhite,
    padding: 0,
    textAlign: 'center',
  },
};

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (value) => EMAIL_REGEX.test(value.trim());
